interface IconProps extends React.SVGProps<SVGSVGElement> {}

export const Bsc = ({ ...props }: IconProps) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_188_26537)">
      <circle
        cx="50"
        cy="50"
        r="50"
        fill="url(#paint0_radial_188_26537)"
      />
      <path
        d="M26.7801 43.224L20 50.0042L26.7801 56.7843L33.5602 50.0042L26.7801 43.224Z"
        fill="black"
      />
      <path
        d="M50.0019 43.2207L43.2217 50.0008L50.0019 56.781L56.782 50.0008L50.0019 43.2207Z"
        fill="black"
      />
      <path
        d="M73.2209 43.2202L66.4407 50.0004L73.2209 56.7805L80.001 50.0004L73.2209 43.2202Z"
        fill="black"
      />
      <path
        d="M50.0024 66.4398L43.2223 73.2199L50.0024 80L56.7826 73.2199L50.0024 66.4398Z"
        fill="black"
      />
      <path
        d="M56.7807 59.6602L50.0006 66.4403L56.7807 73.2204L63.5608 66.4403L56.7807 59.6602Z"
        fill="black"
      />
      <path
        d="M61.6091 54.8324L56.7803 59.6612L63.5604 66.4413L68.3892 61.6125L61.6091 54.8324Z"
        fill="black"
      />
      <path
        d="M43.2212 73.2178L50.0013 79.9979L56.7815 73.2178L50.0013 66.4377L43.2212 73.2178Z"
        fill="black"
      />
      <path
        d="M36.4402 66.4421L43.2203 73.2222L50.0004 66.4421L43.2203 59.6619L36.4402 66.4421Z"
        fill="black"
      />
      <path
        d="M31.6106 61.6079L36.4394 66.4367L43.2195 59.6566L38.3907 54.8278L31.6106 61.6079Z"
        fill="black"
      />
      <path
        d="M49.999 33.5617L56.7791 26.7816L49.999 20.0015L43.2189 26.7816L49.999 33.5617Z"
        fill="black"
      />
      <path
        d="M43.2219 40.3414L50.0021 33.5613L43.2219 26.7812L36.4418 33.5613L43.2219 40.3414Z"
        fill="black"
      />
      <path
        d="M38.3952 45.1688L43.224 40.34L36.4439 33.5598L31.6151 38.3887L38.3952 45.1688Z"
        fill="black"
      />
      <path
        d="M56.7841 26.7801L50.004 20L43.2239 26.7801L50.004 33.5602L56.7841 26.7801Z"
        fill="black"
      />
      <path
        d="M63.5584 33.5597L56.7783 26.7796L49.9981 33.5597L56.7783 40.3398L63.5584 33.5597Z"
        fill="black"
      />
      <path
        d="M68.388 38.3903L63.5591 33.5615L56.779 40.3416L61.6078 45.1705L68.388 38.3903Z"
        fill="black"
      />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_188_26537"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(50 50) rotate(45) scale(113.844)"
      >
        <stop stopColor="#F2B92E" />
        <stop
          offset="1"
          stopColor="#8C6B1B"
        />
      </radialGradient>
      <clipPath id="clip0_188_26537">
        <rect
          width="100"
          height="100"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
